import { render } from "./FileUpload.vue?vue&type=template&id=36f4263d&scoped=true&ts=true"
import script from "./FileUpload.vue?vue&type=script&lang=ts"
export * from "./FileUpload.vue?vue&type=script&lang=ts"

import "./FileUpload.vue?vue&type=style&index=0&id=36f4263d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f4263d"]])

export default __exports__